const MAX_SIZE_BYTES = 1024 * 1024
const ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/bmp']

function loadImage(file) {
   return new Promise((resolve, reject) => {
      const img = new Image()
      const url = URL.createObjectURL(file)

      img.onload = () => {
         URL.revokeObjectURL(url)
         resolve(img)
      }

      img.onerror = () => {
         URL.revokeObjectURL(url)
         reject(new Error('Unable to read this image. Please upload a clear JPG, PNG, or BMP photo.'))
      }

      img.src = url
   })
}

function getImageStats(img) {
   const canvas = document.createElement('canvas')
   const size = 64
   canvas.width = size
   canvas.height = size

   const ctx = canvas.getContext('2d')
   ctx.drawImage(img, 0, 0, size, size)

   const data = ctx.getImageData(0, 0, size, size).data
   let skinLike = 0
   let saturated = 0
   let dark = 0
   let light = 0

   for (let i = 0; i < data.length; i += 4) {
      const r = data[i]
      const g = data[i + 1]
      const b = data[i + 2]
      const max = Math.max(r, g, b)
      const min = Math.min(r, g, b)

      if (r > 95 && g > 40 && b > 20 && max - min > 15 && r > g && r > b) {
         skinLike++
      }

      if (max - min > 90) {
         saturated++
      }

      if (max < 45) {
         dark++
      }

      if (min > 235) {
         light++
      }
   }

   const total = data.length / 4
   return {
      skinRatio: skinLike / total,
      saturatedRatio: saturated / total,
      darkRatio: dark / total,
      lightRatio: light / total,
   }
}

export async function validateProfessionalPhoto(file) {
   if (!file) {
      return { valid: false, message: 'Professional photo is required.' }
   }

   if (!ACCEPTED_TYPES.includes(file.type)) {
      return { valid: false, message: 'Only JPG, PNG, or BMP professional photo is allowed.' }
   }

   if (file.size > MAX_SIZE_BYTES) {
      return { valid: false, message: 'Photo size must not exceed 1MB.' }
   }

   const img = await loadImage(file)
   const minSide = Math.min(img.naturalWidth, img.naturalHeight)
   const maxSide = Math.max(img.naturalWidth, img.naturalHeight)
   const ratio = maxSide / minSide

   if (minSide < 180) {
      return { valid: false, message: 'Photo is too small. Please upload a clear professional face photo.' }
   }

   if (ratio > 1.65) {
      return { valid: false, message: 'Please upload a portrait-style professional photo, not a wide screenshot or document.' }
   }

   const stats = getImageStats(img)

   if (stats.darkRatio > 0.55 || stats.lightRatio > 0.75) {
      return { valid: false, message: 'Photo is not clear enough. Please upload a clear face photo.' }
   }

   if (stats.saturatedRatio > 0.55 && stats.skinRatio < 0.03) {
      return { valid: false, message: 'This does not look like a professional face photo.' }
   }

   return { valid: true, message: 'Professional photo accepted.' }
}
